<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-17 16:55:55
 * @LastEditTime: 2019-08-17 16:56:57
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    title="选择产品"
    :visible="true"
    :append-to-body="true"
    width="60%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      <el-form-item label="生产批次号:" v-if="isCodeShow">
        <el-input v-model="form.production_batch" clearable></el-input>
      </el-form-item>
      <el-form-item label="产品编号:">
        <el-input v-model="form.product_sn" clearable></el-input>
      </el-form-item>

      <el-form-item label="产品名称:">
        <el-input v-model="form.product_name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getData()">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      height="350"
      border
      stripe
      fit
      style="width: 100%"
    >
      <el-table-column v-if="isCodeShow" prop="production_batch" label="产品图片" width="180" fixed>
          <template slot-scope="scope">
            <div class="product_img">
         <img :src="scope.row.product_img" alt="">

            </div>
        </template>
      </el-table-column>
      <el-table-column prop="product_sn" label="产品编号" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="product_name" width="200" label="产品名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="category_name" width="100" label="产品分类" show-overflow-tooltip></el-table-column>
      <el-table-column prop="product_bar_code" label="条码" show-overflow-tooltip></el-table-column>
      <el-table-column prop="product_specs" width="100" label="产品规格" show-overflow-tooltip></el-table-column>

      <!-- <el-table-column prop="product_specs" width="100" label="商品属性" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop label="操作" width="100" show-overflow-tooltip fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[5, 10, 150, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    ></el-pagination>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "selectProducts",
  data() {
    return {
      loading: false,
      form: {
        product_sn: "",
        product_name: "",
        production_batch: ""
      },
      tableData: [],
      //分页
      pageNo: 1,
      pageSize:5,
      totalSize: 0,
      isCodeShow: true
    };
  },
  methods: {
  
    //获取基础配置
    getConfigInfo() {
      this.$get("logistics", "/configs", {
        lang: ""
      })
     
        .then(res => {
      
          if (res.data.production_batch_on_off == 0) {
            this.isCodeShow = false;
          } else if (res.data.production_batch_on_off == 1) {
            this.isCodeShow = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getData() {
      this.loading = true;
      this.$get("logistics", "/products", {
        lang: "",
        product_sn: this.form.product_sn,
        product_name: this.form.product_name,
        production_batch: this.form.production_batch,
        per_page: this.pageSize,
        page: this.pageNo
      })
        .then(res => {
          this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
          console.log(error);
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getData();
    },
    //选择产品
    choose(row) {
      this.$emit("pushData", row);
      this.$emit("handleClose");
    },
    handleClose() {
      this.$emit("handleClose");
    }
  },
  created() {
    // this.getConfigInfo();
    this.getData();
  }
}
</script>
<style lang="scss" scoped>

.product_img{
  height: auto;
  img{
    width: 100%;
  }
}
/deep/td{
  height: 100px!important;
  overflow: visible;
  .cell{
    height: 100%;
    padding-right: 5px;
  }
}
</style>